import React from 'react'

const Message = ({ message, type = 'warning' }) => {
    return <div className={`ytvgbMessage ${type}`}>
        <p dangerouslySetInnerHTML={{
            __html: `${message}`
        }}
        ></p>
        <button className='ytvgbTopBtn' onClick={() => {
            wp.data.dispatch('core/edit-post').openGeneralSidebar('ytvgb-gallery/youTube-video-gallery');
        }}>Configure Api Key</button>
    </div>
}

export default Message